import React  from "react";
import ActAsUserForm from "./components/ActAsUserForm";
import SummaryHeader from "components/header/SummaryHeader";

const ActAsUser = () => {
	
	return (
	    <div>
			<SummaryHeader
				title="Act As User"
				iconName="Users"
				description="Login as another user using your own password."
				color="green"
			/>
	      <div className="mt-5 flex justify-center">      		
	      	<ActAsUserForm/>
	      </div>
	    </div>
    );
};

export default ActAsUser;